import { Component } from '@angular/core';

@Component({
  selector: 'app-identity-layout',
  templateUrl: './identity-layout.component.html',
  styleUrls: ['./identity-layout.component.css']
})
export class IdentityLayoutComponent {

}
